import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  ViewChild,
} from '@angular/core';
import {
  CommonService,
  CONSTANT,
  FileUploadService,
  LoaderService,
  ObservableService,
  OrderService,
  PdfGeneratorService,
} from '@bst-frontend/shared';
import { finalize } from 'rxjs';

@Component({
  selector: 'bst-frontend-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.css'],
})
export class InvoiceComponent {
  generating = false;
  uploadedFileKey: string | null = null;
  uploadedFileUrl: string | null = null;
  uploadedFileSize: number | null = null;
  fileName = '';
  pdfFileName = '';
  @Input() orderData: any;
  @ViewChild('lrTemplate') lrTemplate!: ElementRef<HTMLDivElement>;
  today = new Date();
  orderType: any = CONSTANT.orderType;
  lastIndex = 1;
  truckNumber = '';

  constructor(
    private orderService: OrderService,
    private loader: LoaderService,
    private pdfService: PdfGeneratorService,
    private uploadService: FileUploadService,
    private observableService: ObservableService,
    private cdRef: ChangeDetectorRef,
    private commonService: CommonService,
    @Inject('environment') private environment: any
  ) {}
  ngOnInit(): void {
    console.log('orderData', this.orderData);
  }

  
  getSerialNumber(so: number, di: number, itt: number): number {
  let count = 0;

  for (let s = 0; s < so; s++) {
    for (const d of this.orderData.subOrders[s].deliveries) {
      count += d.items.length;
    }
  }

  for (let d = 0; d < di; d++) {
    count += this.orderData.subOrders[so].deliveries[d].items.length;
  }

  return count + itt + 1;
}
  
getPartLoadSerialNumber(so: number, itt: number): number {
  let sr = 0;

  // count all pickup items from previous suborders
  for (let s = 0; s < so; s++) {
    const prevSub = this.orderData?.subOrders?.[s];
    sr += prevSub?.pickup?.items?.length || 0;
  }

  // add current item index
  return sr + itt + 1;
}


  async onGenerateOrUpdatePdf() {
    this.generating = true;
    try {
      this.loader.show();
      // const currentYear = new Date().getFullYear();
      // const financialYearStart = new Date(currentYear + 1, 3, 1);
      // const financialYearEnd = new Date(currentYear + 2, 2, 31);

      // // Formatting the output as 'BST_2025-26'
      // const financialYearLabel = `BST_${financialYearStart.getFullYear()}-${financialYearEnd
      //   .getFullYear()
      //   .toString()
      //   .slice(-2)}`;
      // const res: any = await this.orderService
      //   .genrateInvoiceNumber()
      //   .toPromise();
      // this.fileName = `${financialYearLabel}_${res.data}.pdf`;
      this.pdfFileName = `${this.fileName}.pdf`;
      this.cdRef.detectChanges();
      // 3) get pdf blob from template
      const pdfBlob = await this.pdfService.generatePdfFromElement(
        this.lrTemplate.nativeElement
      );

      // 4) upload to S3
      this.uploadService
        .uploadFileToS3(pdfBlob, this.pdfFileName, 'invoice', this.orderData._id)
        .pipe(
          finalize(() => {
            this.generating = false;
            this.loader.hide();
          })
        )
        .subscribe({
          next: ({ fileUrl, fileKey }) => {
            this.uploadedFileKey = fileKey;
            this.uploadedFileUrl = fileUrl;
            this.uploadedFileSize = pdfBlob.size;
            this.saveInvoiceData();
            this.onDownloadPdf();
          },
          error: (err) => {
            console.error('Upload error', err);
            alert('Failed to generate/upload LR PDF');
          },
        });
    } catch (e) {
      this.generating = false;
      alert('Failed to generate LR PDF');
      this.loader.hide();
    }
  }
  getRate(item: any): number {
    let rate = 0;
    const qty = item?.planned?.weight;
    if(this.orderData?.type === 'full-load'){
      rate = this.orderData?.estimate;
    } else if(this.orderData?.type === 'part-load-door'){
      rate = (item?.product?.subItems?.price ? item?.product?.subItems?.price / 1000 : item?.product?.price / 1000);
    } else if(this.orderData?.type === 'part-load-office'){
      rate = (item?.product?.subItems?.bstOfficePrice ? item?.product?.subItems?.bstOfficePrice / 1000 : item?.product?.bstOfficePrice / 1000);
    }
    return rate;
  }

  setTruckNumber(truckNo: string) {
    this.truckNumber = truckNo;
  }

  getQty(item: any, productDifferences: any): number {
    return this.commonService.getQty(item, productDifferences);
  }

  getWeight(item: any, productDifferences: any): number {
    if(this.orderData?.type === 'full-load' && this.orderData?.isOrderWeightLessThanActual === true)
    {
      return this.commonService.getWeight(item, productDifferences);
    }
    return this.commonService.getChargeWeight(item, productDifferences);
  }

  getPrice(item: any, rate: number, productDifferences: any): number {
    if(productDifferences?.dispatched){
      const weight = this.getWeight(item, productDifferences);
      return rate * weight;
    }
    return 0;
  }

  async onDownloadPdf() {
    const url = this.uploadedFileUrl;
    if (!url) {
      return;
    }

    // easiest: open new tab OR force download via hidden <a>
    // const a = document.createElement('a');
    // a.href = url;
    // a.download = this.fileName || 'lr.pdf';
    // a.target = '_blank';
    // document.body.appendChild(a);
    // a.click();
    // document.body.removeChild(a);

    try {
      const res = await fetch(url, { method: 'GET' });

      if (!res.ok) throw new Error('Download failed');

      const blob = await res.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = this.pdfFileName || 'invoice.pdf';
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error('PDF download failed', err);
    }
  }

  async saveInvoiceData() {
    // Final payload:
    const payload = {
      invoiceDetail: {
        invoiceFile: {
          path: this.uploadedFileUrl,
          name: this.pdfFileName,
          size: this.uploadedFileSize,
        },
        note: 'Invoice generated and uploaded',
      },
    };
    try {
      await this.orderService
        .updateOrderStatus(
          CONSTANT.orderStatus['INVOICE-UPLOAD'],
          this.orderData._id,
          payload
        )
        .toPromise();
      this.observableService.send({ refresh: true });
      this.loader.hide();
    } catch (error) {
      console.log('Error', error);
    }
  }
}
